export * from 'server/models/TopicCardTemplateUserAssignment';


// WEBPACK FOOTER //
// ./data/models/TopicCardTemplateUserAssignment.ts